import React from 'react'
import { Heading } from '../Common'
import { TitleProps } from './title.props'

export const Title = ({ title, ...rest }: TitleProps) => {
  return <Heading data={title} {...rest} />
}
